import { Button, ButtonSize } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';
import { SystemIcon } from '@oy/uiicon';
import styles from './UpgradeHeader.module.css';
import { UpgradeAlertData } from 'src/constants/UpgradeAlert';
import { useNavigate } from 'react-router-dom';
import { PopupButton } from '@typeform/embed-react';

type UpgradeHeaderProps = {
  upgradeAlertData: UpgradeAlertData;
};

const UpgradeHeader = ({ upgradeAlertData }: UpgradeHeaderProps) => {
  const { getTranslation } = useTranslate();
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div>
        <SystemIcon size={24} name="exclamation" />
      </div>
      <div>{getTranslation(upgradeAlertData.description)}</div>
      <div className={styles.upgradeButton}>
        {upgradeAlertData.typeformId && (
          <PopupButton
            id={upgradeAlertData.typeformId}
            className={styles.popupButton}
          >
            {getTranslation(
              'accountReceivable_onBoarding_informationBannerCTA',
            )}
          </PopupButton>
        )}
        {upgradeAlertData.url && (
          <Button
            className={styles.upgradeButton}
            size={ButtonSize.Medium}
            onClick={() => {
              navigate(upgradeAlertData.url as string);
            }}
          >
            {getTranslation(
              'accountReceivable_onBoarding_informationBannerCTA',
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default UpgradeHeader;
